var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects-widget",on:{"click":function($event){$event.stopPropagation();return _vm.openLink.apply(null, arguments)}}},[_c('donut-widget',{attrs:{"values":_vm.values,"labels":_vm.labels,"show-total":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }